import { render, staticRenderFns } from "./AgrManage.vue?vue&type=template&id=37d0a43c&scoped=true&"
import script from "./AgrManage.vue?vue&type=script&lang=js&"
export * from "./AgrManage.vue?vue&type=script&lang=js&"
import style0 from "./AgrManage.vue?vue&type=style&index=0&id=37d0a43c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d0a43c",
  null
  
)

export default component.exports